export default {
  dialogTitle: "編輯畫布",
  canvasName: {
    label: "畫布名稱",
    placeholder: "請輸入畫布名稱(必填)",
  },
  canvasDescription: {
    label: "畫布描述",
    placeholder: "請描述畫布",
  },
  defaultAddress: {
    label: "預設地址",
    placeholder: "請輸入預設地址",
  },
  buttons: {
    reset: "重置",
    confirm: "確認",
  },
  messages: {
    editSuccess: "修改成功",
    confirmEditRootNode:
      "修改主節點地址，該畫布原有的分析內容將重置，是否要修改？",
    confirmTitle: "提示",
    confirmButton: "確定",
    cancelButton: "取消",
    cancelled: "已取消",
    ruleMessage: "案件名稱為必填項",
  },
};
